export default {
  blocks: {
    trashExpiration: 30,
  },
};
